import { Component, Input, OnInit } from '@angular/core';
import { baseUrls } from 'src/app/appConstant';

@Component({
  selector: 'app-live-stream-card',
  templateUrl: './live-stream-card.component.html',
  styleUrls: ['./live-stream-card.component.scss']
})
export class LiveStreamCardComponent implements OnInit {

  imageUrl = baseUrls.images;
  baseUrl = baseUrls.global;
  constructor() { }
  ngOnInit(): void {
    // console.log('ngOnInit_liveInfo', this.liveInfo);
  }

  @Input('liveInfo')liveInfo;
  
  routeToLiveStream(lineInfoPassed){
    window.location.href = this.baseUrl+'livewell/live/'+lineInfoPassed?.slug;  
  }

}
